<ng-container *ngIf="podcastDetailSoa">
  <app-header-podcast (redirectToContent)="redirectToContent.emit()">
  </app-header-podcast>

  <div class="podcast-main" id="podcast-main">
    <div class="podcast-info">
      <div class="podcast-organization">
        <a
          *ngIf="podcastDetailSoa?.organization"
          class="podcast-organization-text"
          (click)="redirectOrganization()"
          [ngClass]="{ 'cursor-none': !podcastDetailSoa.organization.published }"
        >
          {{ podcastDetailSoa.organization.value }}
        </a>
        <app-score
          [tooltipText]="'Para calificar este podcast escucha al menos un 90% de cualquier episodio'"
          [starInfo]= "enableScore"
          [average]= "podcastDetailSoa.rating"
          [contentId]= "podcastDetailSoa.id"
          [fullWidth]="true">
        </app-score>
      </div>
      <div class="podcast-title">{{ podcastDetailSoa.title }}</div>
    </div>
    <div class="podcast-option">
      <app-follow
        [contentId]="podcastDetailSoa.id"
        [isFollowing]="isFollow"
      >
      </app-follow>
      <app-share
        [mode]="'full'"
        [id]="podcastDetailSoa.id"
        [contentType]="contentType"
        [urlHome]="false"
        [className]="'sharePosition'"
        [title]="podcastDetailSoa.title"
        [description]="podcastDetailSoa.description"
        [fromAnotherElement]="true"
        [uniqueShare]="'share-default'"
      >
        <div textShare class="share-text">COMPARTIR</div>
      </app-share>
    </div>
    <div class="podcast-host">
      <ng-container *ngIf="podcastDetailSoa?.hosts">
        <app-host
          [fromEbook]="false"
          [hosts]="podcastDetailSoa?.hosts"
        ></app-host>
      </ng-container>
    </div>
    <div class="podcast-description">
      <p class="podcast-description-text">
        {{ podcastDetailSoa?.description | cuttext : 192 : seeMore.seeMore }}
      </p>
      <span
        #seeMore
        class="podcast-description-see-more"
        (click)="
          seeMore.seeMore = !seeMore.seeMore; checkIfModalExceedsViewport()
        "
        style="cursor: pointer"
        [hidden]="podcastDetailSoa?.description?.length <= 192"
      >
        {{ !seeMore.seeMore ? "LEER MÁS" : "LEER MENOS" }}
      </span>
    </div>
    <div class="podcast-list" id="list-podcast">
      <app-podcast-list
        [podcastItems]="podcastDetailSoa.episodes.items"
        [podcastTitle]="podcastDetailSoa.name"
        [canPage]="canPaging"
        [loadingSkeleton]="isPaging"
        (paginatePodcastList)="paginatePodcastList()">
      </app-podcast-list>
    </div>
    <div *ngIf="isPlayer" class="podcast-player" id="podcast-player" #podcastPlayer>
      <app-podcast-player [podcastId]="podcastDetailSoa.id"></app-podcast-player>
    </div>
  </div>
</ng-container>
